import { makeStyles, tokens, shorthands } from '@fluentui/react-components';
import { fontScale } from '@/theme/scalingTokens';

export const useCSATSiteCardsStyles = makeStyles({
  root: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
    gap: tokens.spacingHorizontalL,
  },
  card: {
    backgroundColor: tokens.colorNeutralBackground1,
    border: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke2}`,
    ...shorthands.borderRadius(tokens.borderRadiusLarge),
    ...shorthands.padding(tokens.spacingVerticalL, tokens.spacingHorizontalL),
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
    borderLeftWidth: '4px',
    borderLeftStyle: 'solid',
  },
  accentGreen: { borderLeftColor: tokens.colorPaletteGreenForeground1 },
  accentAmber: { borderLeftColor: tokens.colorPaletteMarigoldForeground2 },
  accentRed: { borderLeftColor: tokens.colorPaletteRedForeground1 },
  siteName: {
    fontSize: fontScale.caption,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground3,
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    marginBottom: tokens.spacingVerticalXS,
  },
  score: {
    fontSize: fontScale.subheading,
    fontWeight: tokens.fontWeightBold,
    color: tokens.colorNeutralForeground1,
    lineHeight: '1.3',
  },
  meta: {
    fontSize: fontScale.caption,
    color: tokens.colorNeutralForeground3,
    marginTop: tokens.spacingVerticalXXS,
  },
});
